import { pickedApiRequest } from './request'

/**
 * Employer sign-up, sign-in and link endpoints (see
 * V/knowledge/testcandidates-remediation/EMPLOYER-AUTH-BUILD.md for the
 * contract). Every function resolves to the response body.
 */
export default {
  emailStatus (email) {
    return pickedApiRequest.post('assessment/employers/email-status', { email })
      .then(response => response.data.data)
  },

  signUp (payload) {
    return pickedApiRequest.post('assessment/employers/sign-up', payload)
      .then(response => response.data)
  },

  magicLink (email, device) {
    return pickedApiRequest.post('assessment/employers/magic-link', { email, device })
      .then(response => response.data)
  },

  peekLink (employerId, code) {
    return pickedApiRequest.get(`assessment/employers/${encodeURIComponent(employerId)}/auth-links/${encodeURIComponent(code)}`)
      .then(response => response.data.data)
  },

  exchangeLink (employerId, code, device) {
    return pickedApiRequest.post(`assessment/employers/${encodeURIComponent(employerId)}/auth-links/${encodeURIComponent(code)}`, { action: 'exchange', device })
      .then(response => response.data)
  },

  approveLink (employerId, code, device) {
    return pickedApiRequest.post(`assessment/employers/${encodeURIComponent(employerId)}/auth-links/${encodeURIComponent(code)}`, { action: 'approve', device })
      .then(response => response.data.data)
  },

  pickup (employerId, requestId) {
    return pickedApiRequest.get(`assessment/employers/${encodeURIComponent(employerId)}/auth-requests/${encodeURIComponent(requestId)}`)
      .then(response => response.data.data)
  },

  providerEmail (provider, idToken) {
    return pickedApiRequest.post(`assessment/employers/${provider}-email`, { idToken })
      .then(response => response.data.data)
  },

  providerSignIn (provider, idToken) {
    return pickedApiRequest.post(`assessment/employers/${provider}`, { idToken })
      .then(response => response.data.data)
  },

  providerSignUp (payload) {
    return pickedApiRequest.post('assessment/employers/provider-sign-up', payload)
      .then(response => response.data)
  },

  resendVerification (employerId) {
    return pickedApiRequest.post(`assessment/employers/${encodeURIComponent(employerId)}/resend-verification`)
      .then(response => response.data.data)
  },

  joinInfo (token) {
    return pickedApiRequest.get(`assessment/join/${encodeURIComponent(token)}`)
      .then(response => response.data.data)
  },

  joinRequest (token, payload) {
    return pickedApiRequest.post(`assessment/join/${encodeURIComponent(token)}`, payload)
      .then(response => response.data.data)
  },

  joinLink (organisationId) {
    return pickedApiRequest.post(`assessment/organisations/${encodeURIComponent(organisationId)}/join-link`)
      .then(response => response.data.data)
  },

  inviteCandidate (organisationId, jobUuid, email) {
    return pickedApiRequest.post(`assessment/organisations/${encodeURIComponent(organisationId)}/invite-candidates`, {
      candidates: [{ email, name: '' }],
      jobUuid
    })
      .then(response => response.data.data)
  }
}
